<template>
  <v-sheet
    class="pa-1 fill-height"
    elevation="2"
    rounded
    :class="{ bordered: selected }"
    color="secondarybackground"
  >
    <div class="d-flex justify-space-between">
      <h5 class="pa-2 text-center" v-if="title">
        {{ title }}
      </h5>
      <slot name="title" />
      <slot name="refresh" />
    </div>
    <slot />
  </v-sheet>
</template>

<script>
export default {
  name: 'CustomChartRenderer',
  props: {
    title: {
      type: String,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
